import React from 'react'

import SkipNavigation from '@Components/VAC/common/SkipNavigation'
import AlarmPopup from '@Components/alarm/popup/AlarmPopup'
import useUser from '@Hooks/user/useUser'
import MyhouseRegisterRestrictGroupIdPopup from '@Components/atoms/MyhouseRegisterRestrictGroupIdPopup'
import MyhouseRegisterRestrictSnsIdPopup from '@Components/atoms/MyhouseRegisterRestrictSnsIdPopup'
import MyhouseRegisterRestrictAgePopup from '@Components/atoms/MyhouseRegisterRestrictAgePopup'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

type Props = {
  children: React.ReactNode
}

const AlarmLayout: React.FC<Props> = ({ children }: Props) => {
  const { user } = useUser()

  const handleCloseClick = () => {
    if (window.location.pathname.includes('myasset')) {
      window.location.href = `${process.env.REACT_APP_NAVER_MYMONEY_URL}`
    } else {
      window.location.href = `${process.env.REACT_APP_SPACE_WEB_URL}`
    }
  }
  return (
    <>
      <SkipNavigation />
      {children}
      <AlarmPopup />
      {(user.isGroupId && (
        <MyhouseRegisterRestrictGroupIdPopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.ID, handleCloseClick)} />
      )) ||
        (user.isSnsId && <MyhouseRegisterRestrictSnsIdPopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.ID, handleCloseClick)} />) ||
        (user.userOld < 14 && <MyhouseRegisterRestrictAgePopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.AGE, handleCloseClick)} />)}
    </>
  )
}

export default AlarmLayout
